var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import spinnerPrimary from '../../img/loadingSpinner.svg';
import spinnerSecondary from '../../img/loadingSpinnerSecondary.svg';
const spinner = keyframes `
  to {
    transform: rotate(360deg);
  }
`;
const SpinnerStyle = styled.div `
  display: inline-block;
  height: ${props => props.height};
  width: ${props => props.width};
  margin: ${props => props.marginXL ? props.theme.paddingsMargins.themeMenuMargin : props.marginSM ? props.theme.paddingsMargins.themeMenuMargin : null};
  transform-origin: 50 50;
  animation: ${spinner} 800ms infinite linear;
`;
const Spinner = (_a) => {
    var { marginXL = false, marginSM = false, secondary, height = '2rem', width = '2rem' } = _a, props = __rest(_a, ["marginXL", "marginSM", "secondary", "height", "width"]);
    return (_jsx(SpinnerStyle, Object.assign({ marginXL: marginXL, marginSM: marginSM, height: height, width: width }, props, { style: {
            background: `url(${secondary ? spinnerSecondary : spinnerPrimary})`
        } })));
};
export default Spinner;
